import { formatCurrency } from '@/lib/utils'
import type { CurrentWeekNetworkFixedCdSnapshot } from '@/services/networkFixedCdService'

interface NetworkFixedCdCardProps {
  snapshot: CurrentWeekNetworkFixedCdSnapshot
  compact?: boolean
}

function formatSnapshotDate(value: string): string {
  return new Date(`${value}T00:00:00`).toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
  })
}

export function NetworkFixedCdCard({
  snapshot,
  compact = true,
}: NetworkFixedCdCardProps) {
  const paddingClass = compact ? 'px-3 py-2' : 'px-4 py-2.5'

  return (
    <div
      className={`rounded-lg border border-amber-200/80 bg-amber-50/60 ${paddingClass}`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="text-[9px] font-semibold uppercase tracking-[0.14em] text-amber-700">
          Цифра дня сети
        </div>

        <div className="rounded bg-amber-200/60 px-1.5 py-0.5 text-[9px] font-medium leading-none text-amber-800">
          {formatSnapshotDate(snapshot.snapshot_date)}
        </div>
      </div>

      <div className="mt-1.5 grid grid-cols-[minmax(0,1fr)_auto] gap-3 border-t border-amber-200/70 pt-1.5">
        <div>
          <div className="whitespace-nowrap text-lg font-semibold leading-none text-neutral-900">
            {formatCurrency(snapshot.fixed_cd_rub)}
          </div>

          <div className="mt-1 text-[10px] leading-none text-neutral-500">
            на студию в день
          </div>
        </div>

        <div className="border-l border-amber-200/70 pl-3 text-right">
          <div className="text-[9px] leading-none text-neutral-500">
            Осталось дней
          </div>

          <div className="mt-1 text-[11px] font-semibold leading-none text-neutral-800">
            {snapshot.days_remaining}{' '}
            {snapshot.days_remaining === 1 ? 'день' : 'дн.'}
          </div>
        </div>
      </div>
    </div>
  )
}
